var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m15.374 12.718 4.506-3.055A2.547 2.547 0 0 0 21 7.552v0A2.551 2.551 0 0 0 18.45 5H5.565a2.55 2.55 0 0 0-2.55 2.551v0a2.55 2.55 0 0 0 1.12 2.112l4.505 3.055a6 6 0 0 0 6.733 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3 7.551V17a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7.552"
  })));
};
export { SvgEmail as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZGQ0N2U4NDkyYjY2NGRlOWY3ZTE4NmFiYWE5M2ZhN2Yuc3ZnIjs=";